import React from "react";
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/Loader';
import AuthService from "../services/AuthService";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, userDetails, isLoading, isAdminUser } = useAuth();
  if (isLoading) {
    return <Loader />;
  }
  
  if (isAuthenticated) {
    if(!isAdminUser) {
      const parsedUserDetails = AuthService.ensureParsed(userDetails);
      if (parsedUserDetails.current_subscription_id) {
        return children;
      } else {
        return <Navigate to="/pricing" />;
      }
    } else {
      return <Navigate to="/error/401" />;
    }
  } else {
    return <Navigate to="/login" />; // User is not authenticated, redirect to login
  }
};

export default ProtectedRoute;